import { render, staticRenderFns } from "./ClusterEvents.vue?vue&type=template&id=92367748&scoped=true"
import script from "./ClusterEvents.vue?vue&type=script&lang=js"
export * from "./ClusterEvents.vue?vue&type=script&lang=js"
import style0 from "./ClusterEvents.vue?vue&type=style&index=0&id=92367748&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92367748",
  null
  
)

export default component.exports